module.exports = __webpack_public_path__ + "static/media/goal-penalty.dde1978a.svg";